"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _MKJKL65Rcjs = require('./MKJKL65R.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/popover/popover-description.tsx
var TagName = "p";
var usePopoverDescription = _PTOCUU2Dcjs.createHook.call(void 0, function usePopoverDescription2(props) {
  props = _MKJKL65Rcjs.useDialogDescription.call(void 0, props);
  return props;
});
var PopoverDescription = _PTOCUU2Dcjs.forwardRef.call(void 0, function PopoverDescription2(props) {
  const htmlProps = usePopoverDescription(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.usePopoverDescription = usePopoverDescription; exports.PopoverDescription = PopoverDescription;
